import React from "react";
import { Tag } from "lucide-react";
import { Section, StepBadge } from "./ui";

export default function PromoStep({ promoCode, budget, set }) {
  let feedback = null;
  if (promoCode) {
    feedback = budget.promoValid
      ? { className: "text-[#2e7d32]", text: `✓ ${budget.promo.label} aplicada` }
      : { className: "text-[#c0392b]", text: "Código no válido" };
  }

  return (
    <Section>
      <StepBadge n={4} title="Código promocional" subtitle="Aplica un descuento si tienes uno" />
      <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Código promocional (opcional)</label>
      <div className="relative">
        <Tag className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9b8388]" />
        <input
          type="text"
          className="veysa-input pl-9 uppercase"
          placeholder="Introduce aquí tu código promocional"
          value={promoCode}
          onChange={(e) => set({ promoCode: e.target.value })}
        />
      </div>
      {feedback && <p className={`text-xs mt-1.5 ${feedback.className}`}>{feedback.text}</p>}
      <p className="text-xs text-[#9b8388] mt-1.5">Solo puede aplicarse uno de los dos descuentos.</p>
    </Section>
  );
}
